import { render, staticRenderFns } from "./SMSManagement.vue?vue&type=template&id=ecf91b28&scoped=true"
import script from "./SMSManagement.vue?vue&type=script&lang=js"
export * from "./SMSManagement.vue?vue&type=script&lang=js"
import style0 from "./SMSManagement.vue?vue&type=style&index=0&id=ecf91b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf91b28",
  null
  
)

export default component.exports